export default "__VITE_ASSET__DDMaNP_L__"